import { Injectable } from '@angular/core';
import { Subject} from 'rxjs';
import { Router} from '@angular/router';
import { viewConfig} from './../config/config.constants';
/**
 * Class responsible of UI configuration
 */
@Injectable({
  providedIn: 'root'
})
export class UiConfigService {
  public config: Subject<any> = new Subject<any>();
  public status = true;
  queryParam: any = {};
  defaultTabUrl: string;
  constructor(private router: Router) { }

  /**
   * Pull view configuration from constants
   */
  setup(routeData: any): any {
    const data = viewConfig.get(routeData) || {
      heading: true,
      greeting: true,
      tabs: true,
      footer: true,
      cssClass: ''
    };
    this.config.next(data);
    return data;
  }
  /**
   * Save or merge opportunityID and campaignID in _config
   */
  saveQueryParams (data, opt: 'save'|'merge' = 'save') {
    if (data) {
      this.queryParam = opt === 'merge' ? Object.assign(this.queryParam, data) : data;
    }
  }
}
